import { Grid, Dialog, DialogContent, Button } from '@mui/material'
import { isEqual } from 'lodash'
import { memo } from 'react'
import GetDocument from '../../../components/Documento'

export const ModalVisualizaDocumento = ({ show, handleClose, dados }) => {
  return (
    <Dialog maxWidth="lg" open={show} onClose={handleClose} fullWidth>
      <DialogContent>
        <Grid container style={{ padding: 0 }}>
          <Grid item xs={12}>
            <GetDocument dsTokenArquivo={dados} />
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" onClick={handleClose}>
              fechar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default memo(ModalVisualizaDocumento, isEqual)
